import { getToken, messaging } from "./firebase";

// taking users permission to generate an fcm token to send it to the backend as a device token.
export const requestPermission = async (registration) => {
    try {
        const permission = await Notification.requestPermission();
        console.log('permission', localStorage.getItem('fcmToken'));
        // only going to call it if user says yes on permissions and no fcm token exist on localstorage.
        if (permission === 'granted' && !localStorage.getItem('fcmToken')) {
            const currentToken = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_VAPID_KEY,
                serviceWorkerRegistration: registration,
            });
            if (currentToken) {
                localStorage.setItem('fcmToken', currentToken)
                return true
            }
            else {
                return false
            }
        } else {
            console.log('Notification permission not granted.');
            return false
        }
    } catch (err) {
        console.error('Error getting FCM token:', err);
        return err
    }
};
